import { render, staticRenderFns } from "./DetailShippingInfor.vue?vue&type=template&id=507e1c7c"
import script from "./DetailShippingInfor.vue?vue&type=script&lang=js"
export * from "./DetailShippingInfor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports